var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_787_6789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30321 17.1839H12.8273C13.2618 17.1839 13.6032 16.8644 13.6032 16.4577C13.6032 16.051 13.2618 15.7314 12.8273 15.7314H7.30321C6.86872 15.7314 6.52734 16.051 6.52734 16.4577C6.52734 16.8644 6.86872 17.1839 7.30321 17.1839Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6517 6H5.34828C3.23793 6 1.5 7.62676 1.5 9.60211V20.9604C1.5 22.9357 3.23793 24.5625 5.34828 24.5625H24.6517C26.7621 24.5625 28.5 22.9357 28.5 20.9604V9.60211C28.5 7.62676 26.7621 6 24.6517 6ZM26.9793 20.9604C26.9793 22.1514 25.9552 23.1391 24.6517 23.1391H5.34828C4.07586 23.1391 3.02069 22.1805 3.02069 20.9604V12.4199H26.9483V20.9604H26.9793ZM26.9793 10.9965H3.02069V9.60211C3.02069 8.41109 4.04483 7.42342 5.34828 7.42342H24.6517C25.9241 7.42342 26.9793 8.38204 26.9793 9.60211V10.9965Z",
    fill: "#565656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_787_6789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 18.5625,
    fill: "white",
    transform: "translate(1.5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.0394e3aa.svg";
export { ForwardRef as ReactComponent };